import { Link } from "react-router-dom";
import { WhatsappLogo, Phone, MapPin } from "@phosphor-icons/react";
import { SITE, whatsappLink } from "../lib/data";
import logoWhite from "../assets/logo-white.png";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-primary text-primary-foreground">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src={logoWhite} alt="Cleansof" className="h-14 w-auto mb-6" />
            <p className="text-primary-foreground/60 font-light max-w-sm leading-relaxed">
              {SITE.tagline} Ci prendiamo cura del tuo immobile mentre tu ti concentri sui tuoi ospiti.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-primary-foreground/40 mb-5">Naviga</div>
            <ul className="space-y-3 font-light">
              <li><Link to="/" className="hover:text-secondary transition-colors">Home</Link></li>
              <li><Link to="/servizi" className="hover:text-secondary transition-colors">Servizi</Link></li>
              <li><Link to="/chi-siamo" className="hover:text-secondary transition-colors">Chi Siamo</Link></li>
              <li><Link to="/contatti" className="hover:text-secondary transition-colors">Contatti</Link></li>
              <li><Link to="/login" className="text-primary-foreground/40 hover:text-secondary transition-colors">Area Riservata</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-primary-foreground/40 mb-5">Contatti</div>
            <ul className="space-y-4 font-light">
              <li><a href={whatsappLink()} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-secondary transition-colors"><WhatsappLogo size={20} weight="fill" /> WhatsApp</a></li>
              <li><a href={`tel:${SITE.phoneHref}`} className="flex items-center gap-3 hover:text-secondary transition-colors"><Phone size={20} /> {SITE.phone}</a></li>
              <li className="flex items-center gap-3 text-primary-foreground/60"><MapPin size={20} /> Roma, Italia</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/10 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-sm text-primary-foreground/40">
          <span>© {new Date().getFullYear()} Cleansof. Tutti i diritti riservati.</span>
          <span>Pulizie & Biancheria per Case Vacanza — Roma</span>
        </div>
      </div>
    </footer>
  );
}
